<template>
	<div style="padding: 15%">
		Denying Guest...
	</div>
</template>

<script>
import axios from 'axios'
export default {
	name: 'rsvp-deny-guest',
	created() {
		axios
			.get(
				'/api/v1/event/' +
					this.$route.params.event_slug +
					'/deny-guest/' +
					this.$route.params.guest_id +
					'/'
			)
			.then(response => {
				this.$router.replace({
					name: 'event',
					params: { slug: this.$route.params.event_slug }
				})
			})
			.catch(error => {
				console.error(error)
			})
	}
}
</script>
